(() => {
  const SLIDER_SELECTOR = ".js-slider-collections-slider";

  const buildOptions = (el, section) => {
    const speed = Number(el.getAttribute("data-duration")) || 600;
    const columnCount = Number(el.getAttribute("data-column-count")) || 6;
    const mobileSlides = parseFloat(el.getAttribute("data-mobile-slides")) || 2;

    const prevBtn = section.querySelector(".swiper-button-prev");
    const nextBtn = section.querySelector(".swiper-button-next");

    // These must stay in sync with the pre-init CSS in the section's
    // {% style %} block, otherwise the layout will shift on first paint.
    const spvSm = Math.max(columnCount - 4, 1) + 0.66;
    const spvMd = Math.max(columnCount - 2, 1) + 0.66;
    const spvLg = Math.min(columnCount, 6) + 0.56;
    const spvXl = columnCount + 0.56;

    return {
      slidesPerView: mobileSlides,
      spaceBetween: 16,
      autoplay: false,
      direction: "horizontal",
      loop: false,
      speed: speed,
      shortSwipes: true,
      longSwipes: true,
      allowTouchMove: true,
      watchOverflow: true,
      // Let Swiper handle container/viewport changes itself instead of
      // destroying and re-creating the instance on every resize.
      observer: true,
      observeParents: true,
      resizeObserver: true,
      navigation:
        prevBtn && nextBtn ? { nextEl: nextBtn, prevEl: prevBtn } : false,
      breakpoints: {
        576: { slidesPerView: spvSm, spaceBetween: 16 },
        990: { slidesPerView: spvMd, spaceBetween: 20 },
        1150: { slidesPerView: spvLg, spaceBetween: 20 },
        1250: { slidesPerView: spvXl, spaceBetween: 20 },
      },
      mousewheel: {
        forceToAxis: true,
      },
    };
  };

  const initSlider = (el) => {
    if (!el) return;
    // Guard against double initialisation - this was the main cause of the
    // "images go big for a second" flash: the slider was built once, then
    // destroyed (which strips Swiper's inline widths) and built again.
    if (el.swiper) return;
    if (typeof Swiper === "undefined") return;

    const section = el.closest(".collections__grid") || document;
    new Swiper(el, buildOptions(el, section));
  };

  const initAll = (root) => {
    const scope = root || document;
    scope.querySelectorAll(SLIDER_SELECTOR).forEach(initSlider);
  };

  const destroyAll = (root) => {
    const scope = root || document;
    scope.querySelectorAll(SLIDER_SELECTOR).forEach((el) => {
      if (el.swiper) el.swiper.destroy(true, true);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll());
  } else {
    initAll();
  }

  // Theme editor support.
  document.addEventListener("shopify:section:load", (event) => {
    destroyAll(event.target);
    initAll(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    destroyAll(event.target);
  });
})();